import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import { AppModule } from '@modules/core/plugins/AppModule';
import {
  GROUPS_OF_ADMINS_MAIN_ROUTE_NAME,
} from '@modules/groups-of-admins/constants';
import {
  GROUPS_OF_ADMINS_CREATE_ROUTE_NAME,
  TRANSLATION_GROUPS_OF_ADMINS_CREATE,
} from '@modules/groups-of-admins/submodules/create/constants';
import { getTranslationKeys } from '@modules/groups-of-admins/submodules/create/translations';

export class GroupsOfAdminsCreateModule extends AppModule {
  addRoutes(router: AppVueRouter): void {
    router.addChildRoute(GROUPS_OF_ADMINS_MAIN_ROUTE_NAME, {
      name: GROUPS_OF_ADMINS_CREATE_ROUTE_NAME,
      path: 'create',
      component: () => import('@modules/groups-of-admins/submodules/create/pages/GroupsOfAdminsCreatePage/GroupsOfAdminsCreatePage.vue'),
    });
  }

  addMenu(): void {}

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUPS_OF_ADMINS_CREATE, getTranslationKeys);
  }
}
